<template>
    <v-container fill-height fluid>
  
      <v-row class="text-center" justify="center">
        <v-col cols="12" style="max-width: 500px;">
            <div class="d-none d-sm-flex" style="height:64px;"></div>

                <v-row class="text-center" justify="center">
                    <v-col cols="12" sm="12">
                        <div class="d-none d-sm-flex" style="height:64px;"></div>
                        <v-img
                            alt="Telekom Voyo Logo"
                            class="ml-auto mb-0 pb-0"
                            contain
                            :src="require('@/assets/logos/telekom-voyo-1.png')"
                            transition="scale-transition"
                            height="58"
                            style="filter: invert(0%); float: center;"
                            v-if="tenant == 'GO' || tenant == 'TMCZ_GO'"
                            />
                            <v-img
                            alt="Digi Voyo Logo"
                            class="ml-auto"
                            contain
                            :src="require('@/assets/logos/digi-voyo-1.png')"
                            transition="scale-transition"
                            height="58"
                            style="filter: invert(0%); float: center;"
                            v-if="tenant == 'DIGI'"
                            />
                    </v-col>
                </v-row>

                <v-row class="text-center" justify="center">
                    <v-col cols="9" sm="9">
                        <v-img
                            alt="Unauthorized Image"
                            class="ml-auto"
                            contain
                            :src="require('@/assets/unauthorized/unauthorized-image.png')"
                            transition="scale-transition"
                            style="filter: invert(0%); float: center;"
                            />
                    </v-col>
                </v-row>

                <v-row class="text-center" justify="center">
                <v-col cols="12" sm="12">
                    <p class="mb-1 heading1 text-center">{{print('PARTNER.VOYO.SSO_WEB.SMS_DEEPLINK_INVALID_TITLE')}}</p>
                    <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                    <!--p class="mb-1 heading2 text-center" v-html="print('PARTNER.VOYO.SSO_WEB.LOGIN_DESCRIPTION')"></p-->
                    <p class="mb-1 heading2 text-left pl-3 pr-3">
                        <b>{{print('PARTNER.VOYO.SSO_WEB.SMS_DEEPLINK_INVALID_DESCRIPTION')}}</b><br><br>
                        <span v-html="$sanitize(print('PARTNER.VOYO.SSO_WEB.SMS_DEEPLINK_INVALID_STEPS'))">
                            1. Prejdite na stránku voyo.sk<br>
                            2. Vyberte "Prihlásiť cez operátora"<br>
                            3. Zvoľte Telekom<br>
                            4. Zadajte prihlasovacie údaje z sms alebo e-mailu o aktivácii služby Voyo štart<br>
                        </span>
                    </p>
                </v-col>
                </v-row>

                <v-row justify="center">
                <v-col cols="10" sm="10" class="pt-0 pb-5">
                    <v-btn block x-large
                        type="submit"
                        :color="tenantColor"
                        class="white--text"
                        @click="redirectToPage('https://voyo.markiza.sk/')"
                        style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{print('PARTNER.VOYO.SSO_WEB.SMS_DEEPLINK_INVALID_BUTTON_VOYO')}}
                    </v-btn>
                </v-col>
                </v-row>
                <v-row justify="center">
                <v-col cols="10" sm="10" class="pt-0 pb-15"><!-- class="d-none d-sm-flex" -->
                    <v-btn block x-large color="secondary"
                        @click="redirectToPage('https://www.telekom.sk/televizia/voyo/mam-zaujem')"
                        style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{print('PARTNER.VOYO.SSO_WEB.SMS_DEEPLINK_INVALID_BUTTON_NATIVE')}}
                    </v-btn>
                </v-col>
            </v-row>
          </v-col>
      </v-row>
  
    </v-container>
  </template>
  
  <style>
    .heading1 {
        text-align: left;
        font-size: 30px;
        line-height: 1.2;
    }
    .heading2 {
        text-align: left;
        font-size: 18px;
        line-height: 1.2;
        letter-spacing: 0.7px;
    }
  
    .v-text-field {
        font-size: 1.5em;
        font-weight: 100;
    }
  
    .v-btn {
        text-transform: none;
        color: #EBEBEB;
        font-size: 1.5em !important;
        letter-spacing: normal;
    }
  </style>
  
  <script>
    import { api } from "../main";
    import VueCookies from 'vue-cookies'

    export default {
      name: 'UnauthorizedView',
  
      data: () => ({
        mystatus: true,
        partner_id: '',
        tenant: 'GO',
        language: 'SK'
      }),
  
      props: ['languagestrings', 'toperror'],
  
      computed: {
        flowType() {
          var flowType = VueCookies.get('flow');
          //console.log('flowType', flowType);
          return flowType;
        },
        redirect_uri() {
          var redirect_uri = VueCookies.get('redirect_uri');
          return redirect_uri;
        },
        state() {
          var state = VueCookies.get('state');
          return state;
        },
        /*
        tenant() {
          return VueCookies.get('tenant');
        },*/
        loginPath() {
            return VueCookies.get('loginPath');
        },
        tenantColor() {
            return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E'; // '#0095DA'
        }
      },
  
      components: {
      },
  
      methods: {
        print(input_prop) {
            return api.print(this.languagestrings, input_prop);
        },

        redirectToPage(url) {
            window.location.href = url
        },

        updateLanguage() {
            this.$emit('updateLanguage', this.language);
        }
      },
  
      created: async function() {
      }
    }
  </script>